var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlerts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "inherit",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "inherit",
    fillRule: "evenodd",
    d: "M12 24c1.31 0 3-.685 3-2H9c0 1.315 1.69 2 3 2zm8-6v-7.87c0-3.695-2.544-6.674-6-7.506V2c0-1-1-2-2-2s-2 1-2 2v.624c-3.457.832-6 3.81-6 7.506V18l-2 1v1h20v-.933L20 18zm-2 0H6v-8c0-2.98 3.02-6 6-6s6 3.15 6 6.13V18z",
    className: "inner-path"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlerts);
export default __webpack_public_path__ + "static/media/alerts.fc09d411e745eb4a7c73f8a2dbc62b75.svg";
export { ForwardRef as ReactComponent };